
import {Inject, Injectable, DOCUMENT} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
   providedIn: 'root',
})

export class SEOService {
  constructor(private title: Title, private meta: Meta, @Inject(DOCUMENT) private dom: Document) { }

   updateTitle(title: string) {
      this.title.setTitle(title);
   }

   updateOgUrl(url: string) {
      this.meta.updateTag({ name: 'og:url', content: url })
   }

   updateDescription(desc: string) {
      this.meta.updateTag({ name: 'description', content: desc })
   }

   updateKeywords(keywords: string) {
      this.meta.updateTag({ name: 'keywords', content: keywords })
   }

   updateRobots(content: string) {
      this.meta.updateTag({ name: 'robots', content: content })
   }

   updateCanonicalUrl(url: string): void {
      let canURL = url == undefined ? this.dom.URL : url;
      const head = this.dom.getElementsByTagName('head')[0];

      let element: HTMLLinkElement = this.dom.querySelector("link[rel='canonical']") as HTMLLinkElement;
      if (element == null) {
         element = this.dom.createElement('link') as HTMLLinkElement;
         element.setAttribute('rel', 'canonical');
         head.appendChild(element);
      }
      element.setAttribute('href', canURL);
     }

   updateJsonLd(data: any) {
      const head = this.dom.getElementsByTagName('head')[0];
      let element: HTMLScriptElement = this.dom.querySelector("script[id='musaffa-json-ld']") as HTMLScriptElement;
      if (element == null) {
         element = this.dom.createElement('script') as HTMLScriptElement;
         element.setAttribute('type', 'application/ld+json');
         element.setAttribute('id', 'musaffa-json-ld');
         head.appendChild(element);
      }
      // Escaping closing script tags within the JSON to prevent premature script termination
      const jsonString = JSON.stringify(data).replace(/<\/script>/g, '<\\/script>');
      element.text = jsonString;
   }
}